<template>
    <div>
        <section class="signup_area">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-container d-flex">

                            <div class="form-wrap">
                                <div class="cardify signup_form">
                                    <div class="login--header pb-2">
                                        <h3>Забыли пароль? Не проблема!</h3>
                                        <p>Пожалуйста, введите Ваш номер телефона.</p>
                                        <div class="alert alert-danger mt-2 mb-0" role="alert" v-if="numberNotIsset">
                                            <span class="alert_icon lnr lnr-warning"></span>
                                            Такой номер в базе не найден!
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                <span class="lnr lnr-cross" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                        <div class="alert alert-success mt-2 mb-0" role="alert" v-if="sendSuccess">
                                            <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                            <strong>Успешно!</strong> Смс с новым паролем была отправлена!
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                <span class="lnr lnr-cross" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                    <!-- end .login_header -->

                                    <div class="login--form pt-0">

                                        <div class="form-group">
                                            <label for="phone">Ваш телефон</label>
                                            <input id="phone" type="text" v-model="$v.formData.phone.$model" class="form-control" autocomplete="off" v-mask="'+375 (##) ###-##-##'" placeholder="+375 (29) 111-11-11">
                                            <div class="field-error-text" v-if="$v.formData.phone.$error">Поле имеет неверное значение</div>
                                        </div>

                                        <button class="btn btn--md btn--round register_btn" :disabled="$v.formData.$invalid" @click="sendNewPassword">Отправить</button>

                                        <div class="login_assist">
                                            <p>Нет аккаунта? <a href="/auth/register">Зарегистрируйтесь!</a>
                                            </p>
                                        </div>
                                    </div>
                                    <!-- end .login--form -->
                                </div>
                                <!-- end .cardify -->
                            </div>

                        </div>


                    </div>
                    <!-- end .col-md-6 -->
                </div>
                <!-- end .row -->
            </div>
            <!-- end .container -->
        </section>

    </div>
</template>

<script>
    import {mask} from 'vue-the-mask'
    import {helpers, required, minLength, maxLength, sameAs, between, email} from 'vuelidate/lib/validators';

    const phoneValidator = helpers.regex('phone', /^\+375\s\((29|44|33|25)\)\s[1-9]{1}\d{2}-\d{2}-\d{2}$/g);


    export default {
        directives: {mask},
        components:{
        },
        data(){
            return {
                appRoutes: null,
                phoneChangeControl: null,
                numberNotIsset: false,
                sendSuccess: false,
                formData: {
                    phone_stripped: null,
                    phone: null,
                },
            }
        },
        created() {
            this.appRoutes = window.appRoutes;
        },
        watch: {
            formData: {
                handler(val, oldVal) {
                    this.phoneChangeControl = val.phone;
                },
                deep: true
            },
            phoneChangeControl() {
                let self = this;
                self.formData.phone_stripped = self.formData.phone.replace(/(\s|-|\(|\))/gm, '');
            }
        },
        methods: {
            sendNewPassword(){
                let self = this;

                axios.post('/' + self.appRoutes['auth.forgot.sendNewPassword'], self.formData)
                    .then(response => {
                        response = response.data;
                        if (response.success) {
                            self.sendSuccess = true;
                        } else {
                            self.numberNotIsset = true;
                        }
                    })
                    .catch((error) => {

                    })
                    .then();
            }
        },
        validations: {
            formData: {
                phone: {
                    required,
                    phoneValidator
                },
            }

        }
    }
</script>
